// @ts-nocheck
import { toastTypes } from '../../enums';
import { createCredentialsIntegrationStore } from './_shared';

export default createCredentialsIntegrationStore({
  partnerKey: 'Blitz',
  defaultConfigs: { apiUrl: '', apiId: '', transactionId: '', enabled: false },
  toastKeys: { update: toastTypes.blitzUpdateConfigs },
});
